
import api from '@/plugins/api'
import { Component, Vue } from 'vue-property-decorator'
import { addToCartSuccess } from '@/plugins/popups'
import eventBus from '@/plugins/eventBus'
import { ItemModel } from '@/store/models/ItemModel'
import router from '@/router/index'
import { CarouselNextLabel, carouselOption, CarouselPrevLabel, envConfiguration } from '@/plugins/globalStaticDatas'
import { FavoritesStore } from '@/store/stores/FavoritesStore'

@Component
export default class SimilarProducts extends Vue {
  similarProducts: any = []
  showComponent: boolean = false
  carouselOption: Object = carouselOption
  nextLabel: any = CarouselNextLabel()
  prevLabel: any = CarouselPrevLabel()
  favorites: FavoritesStore = FavoritesStore.getInstance()
  carouselKey: number = 1
  envConfigurations: object = envConfiguration

  mounted() {
    this.fetchSimilarProducts()
    this.favorites.loadData()
    eventBus.$on('cart:item-selected', this.fetchSimilarProducts)
  }
  beforeDestroy() {
    eventBus.$off('cart:item-selected', this.fetchSimilarProducts)
  }
  fetchSimilarProducts() {
    this.carouselKey++
    api()
      .get(`/products/${this.$route.params.id}/similar`)
      .then((response) => {
        if (response && response.data.data.length > 0) {
          this.showComponent = true
          this.similarProducts = response.data.data.map((itemData: any) => {
            Object.assign(itemData, {
              isFavorite: this.isProductFavorite(itemData),
            })
            let item = new ItemModel()
            item.factory(itemData)
            return item
          })
        } else {
          this.showComponent = false
          this.similarProducts = []
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
  addToFavorites(product: any) {
    product.addToFavorites()
  }
  isProductFavorite(product: ItemModel) {
    const productExists = (obj: any) => obj.id === product.id
    return this.favorites.getStore().some(productExists)
  }
  addToCart(product: ItemModel) {
    if (product.outOfStock) {
      return
    }
    eventBus.$emit('cart:item-added', product)
    addToCartSuccess()
  }
  productName(productName: string) {
    if (productName === null) return 'Nuk Ka Emër'
    if (productName.split('').length > 50) {
      return `${productName.split(' ').slice(0, 8).join(' ')}...`
    }
    return productName
  }
  goto(id: any) {
    router.push({ path: `/items/${id}` }).catch(() => {})
  }
}
